import { connect } from 'react-redux';
import { useContext } from 'react';
import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getKnmFormRef } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IErknmFormAgreementChange } from 'KnmErknmPackage/MainModule/interfaces/IErknmFormAgreementChange';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { getDecisionFormRef } from 'DecisionPackage/MainModule/selectors/decisionSelectors';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { AgreementsContext } from 'KnmErknmPackage/ErkmAgreementsModule/AgreementsContext';

import { AgreementChangeItem } from './AgreementChangeItem';
import styles from './AgreementsChanges.module.scss';

interface IAgreementsChangesProps {
  id: string;
  isWatchOnlyMain: boolean;
  name: string;
}

interface IAgreementsChangesStoreProps {
  decisionFormRef: IDecisionFormRef | undefined;
  formRef: IKnmFormRef | undefined;
}

const AgreementsChangesWithoutStore = ({
  id,
  isWatchOnlyMain,
  name,
  decisionFormRef,
  formRef,
}: IAgreementsChangesProps & IAgreementsChangesStoreProps) => {
  const { isDecision } = useContext(AgreementsContext);
  const remove = (isDecision ? decisionFormRef : formRef)?.current.mutators.remove;
  const arrayFieldName = `${name}.changes`;

  /**
   * Удаление элемента
   * "Сведений об изменении соглашения"
   */
  const makeRemoveAgreementChangesHandler = (index: number) => () => {
    remove && remove(arrayFieldName, index);
  };

  return (
    <FieldBlock label={'Сведения об изменении соглашения'} className={styles.Wrapper}>
      <FieldArray name={arrayFieldName}>
        {({ fields }: FieldArrayRenderProps<IErknmFormAgreementChange, HTMLElement>) => {
          if (!fields.length) {
            return null;
          }

          return fields.map((_name, index) => {
            const fieldValue: IErknmFormAgreementChange = fields.value?.[index];
            const itemArrayId = `${id}.changes[${fieldValue.guid || ''}]`;

            return (
              <AgreementChangeItem
                key={itemArrayId}
                id={itemArrayId}
                index={index}
                onRemove={makeRemoveAgreementChangesHandler(index)}
                name={_name}
                formRef={isDecision ? decisionFormRef : formRef}
                value={fieldValue}
                watchOnlyMain={isWatchOnlyMain}
              />
            );
          });
        }}
      </FieldArray>
    </FieldBlock>
  );
};

const mapStateToProps = (state: IRootState): IAgreementsChangesStoreProps => ({
  formRef: getKnmFormRef(state),
  decisionFormRef: getDecisionFormRef(state),
});

export const AgreementsChanges = connect(mapStateToProps)(AgreementsChangesWithoutStore);
